import React from "react";
import styled from "styled-components";

export default function HandoutLayoutControls({ settings, onChange }) {
  return <Controls aria-label="講義題目排版">
    <legend>題目與簡答排版</legend>
    <label>選項排列<select aria-label="選項排列" value={settings.optionsLayout || "auto"}
      onChange={(event) => onChange("optionsLayout", event.target.value)}>
      <option value="auto">依長度自動排列</option><option value="one">每列 1 個</option>
      <option value="two">每列 2 個</option><option value="four">每列 4 個</option>
    </select></label>
    <label>題圖位置<select aria-label="題圖位置" value={settings.questionFigureLayout || "below"}
      onChange={(event) => onChange("questionFigureLayout", event.target.value)}>
      <option value="below">題文下方</option><option value="beside">小圖排在題文右側</option>
    </select></label>
    <label>題前間距（點）<input type="number" aria-label="題前間距（點）" min="0" max="24" step="1"
      value={settings.questionSpacingPt ?? 0} onChange={(event) => onChange("questionSpacingPt", Number(event.target.value))} /></label>
    <label>簡答大小（點）<input type="number" aria-label="簡答大小（點）" min="8" max="18" step="1"
      value={settings.answerFontSize ?? 12} onChange={(event) => onChange("answerFontSize", Number(event.target.value))} /></label>
    <label className="check"><input type="checkbox" aria-label="簡答粗體" checked={settings.answerBold ?? false}
      onChange={(event) => onChange("answerBold", event.target.checked)} />簡答粗體</label>
    <label className="wide">原稿分頁<select aria-label="原稿分頁方式" value={settings.preserveManualPageBreaks === false ? "flow" : "manual"}
      onChange={(event) => onChange("preserveManualPageBreaks", event.target.value === "manual")}>
      <option value="manual">保留原稿分頁</option><option value="flow">連續排版，單元另起新頁</option>
    </select><small>連續排版只略過匯入的舊分頁；新增的分頁／分節與題目前分頁都會保留。</small></label>
  </Controls>;
}

const Controls = styled.fieldset`
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px;
  border: 1px solid #d6dee8; border-radius: 8px; padding: 12px; margin: 14px 0;
  legend { float: none; width: auto; padding: 0 5px; margin: 0; font-size: 1rem; font-weight: 700; }
  label { display: flex; min-width: 0; flex-direction: column; gap: 5px; font-size: .92rem; }
  input:not([type=checkbox]), select { box-sizing: border-box; width: 100%; min-width: 0; border: 1px solid #cbd5e1; border-radius: 6px; padding: 7px; background: #fff; color: #111827; }
  .check { flex-direction: row; align-items: center; }
  .wide { grid-column: 1 / -1; }
  small { color: #64748b; line-height: 1.4; }
`;
